module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsChristmas.b017e55.jpg";